// prettier-print-width 400

export default class userAuthClass {
  constructor(user, userAsiakas) {
    this.ownerAsiakasId = userAsiakas?.asiakasId;
    this.is = {
      pumppari: false, // henkilö on pumppari
      assignee: false, // henkilölle voidaan jakaa tehtäviä
      asiakasAdmin: false, // henkilöllä on asiakkaan täysi hallintaoikeus
      systemAdmin: false, // henkilö on järjestelmänvalvoja
    };
    this.isLoaded = false;
    this.user = user;
    this.userAsiakas = userAsiakas;
    this.error = { isError: false, message: "" };
    this.action = {
      keikka: { create: false },
      palkki: { create: false },
      person: { delete: false },
    };
    this.page = {
      ai: { read: false },
      admin: { read: false },
      loma: { read: false },
      grid: {
        read: false,
        edit: false,
        drivers: { read: false, edit: false },
        reminders: { read: false, execute: false, create: false },
        settings: { edit: false },
        tilaus: {
          tabs: {
            // tilaus: { read: false },
            // oikeudet: { read: false },
            // jaa: { read: false },
            // historia: { read: false },
            // tehtävät: { read: false },
            // toimitus: { read: false },
            // laskutus: { read: false },
            teksti: { read: false },
          },
        },
      },
      haku: { read: false },
      koti: { read: true },
      lasku: { read: false, edit: false },
      liite: { read: false, list: false, edit: false },
      list: { read: false },
      messages: { read: false },
      report: {
        read: false,
        daily: {
          vehicle: { read: false },
          driver: { read: false },
          capacity: { read: false, send: false },
        },
        stats: {
          dash: { read: false },
          pumppari: { read: false },
          kustannuspaikat: { read: false },
          stat: { read: false, main: { read: false }, vehicleDriver: { read: false } },
        },
      },
      tarjous: { read: false, edit: false },
      tyot: {
        read: false,
        edit: false,
        toimitus: { read: false, selectPerson: false, enterData: false },
        laskutus: { read: false },
        hallinta: { read: false },
        liite: { read: false },
      },
      user: { read: false },
      userAsiakas: { read: false },
      get raport() {
        return this.report;
      },
      get profile() {
        return this.user;
      },
    };
    this.asiakas = { read: false, edit: false, action: { delete: false } };
    this.modules = {
      read: false,
      edit: false,
      henkilöt: { enabled: false, read: false, foreignKeys: { read: false, edit: false } },
      laskutus: { enabled: false, read: false, edit: false },
      pumifi: { enabled: false, read: false, edit: false },
      ajoneuvot: { enabled: false, read: false, edit: false },
      tuotteet: { enabled: false, read: false, edit: false },
      sijainnit: { enabled: false, read: false, edit: false },
      modules: { read: false, edit: false },
    };
    this.asetukset = {
      read: false,
      edit: false,
      roles: { read: false, edit: false },
      lisänimet: { read: false, edit: false },
      vakiot: { read: false, edit: false },
    };
  }

  keikkaDataAuth = (keikkaData) => {
    let response = {
      read: false,
      edit: false,
      modules: {
        toimitus: { enabled: false, read: false, edit: false },
        kuvat: { enabled: false, read: false, upload: false, delete: false },
        lasku: { enabled: false, read: false, edit: false },
        tarjous: { enabled: false, read: false, edit: false },
      },
      toiminnot: { read: false, edit: false },
      viestit: { read: false, edit: false },
      action: { delete: false },
    };
    if (!this.user || !this.userAsiakas) return response;
    if (!keikkaData.auth.read) return response;

    response.action.delete = keikkaData.auth.originalEdit && keikkaData.tila.keikkaTilaId < 2;
    response.read = keikkaData.auth.read;
    response.edit = keikkaData.auth.originalEdit;
    response.toiminnot.read = keikkaData.auth.originalEdit;

    response.viestit.read = keikkaData.auth.isKeikkaAdmin;
    response.viestit.edit = response.viestit.read;

    if (this.userAsiakas) {
      if (this.userAsiakas.hasToimitus) {
        response.modules.toimitus.enabled = true;
        response.modules.toimitus.read = keikkaData.auth.read;
        response.modules.toimitus.edit = keikkaData.auth.originalEdit;
      }
      if (this.userAsiakas.hasTiedostot) {
        response.modules.kuvat.enabled = true;
        response.modules.kuvat.read = keikkaData.auth.read;
        response.modules.kuvat.upload = keikkaData.auth.read;
        response.modules.kuvat.delete = keikkaData.auth.edit;
      }
      if (this.userAsiakas.hasLaskutus) {
        response.modules.lasku.enabled = true;
        response.modules.tarjous.enabled = true;
        if (this.userAsiakas.auth.isLaskuAdmin || this.userAsiakas.auth.isAsiakasAdmin) {
          response.modules.lasku.read = true;
          response.modules.lasku.edit = true;
          response.modules.tarjous.read = true;
        }
      }
    }
    return response;
  };
  personDataAuth = (personData) => {
    let response = {
      read: false,
      edit: false,
      action: { delete: false },
    };
    if (!this.user || !this.userAsiakas) return response;
    const isSelfManaged = personData.lastLoginTime != null;
    if (this.user.personId === personData.personId) {
      response.read = true;
      response.edit = !isSelfManaged;
    }
    if (this.user.isSystemAdmin) {
      response.read = true;
      response.edit = !isSelfManaged;
      response.action.delete = true;
    }
    if (
      personData.ownerAsiakasId === this.userAsiakas.asiakasId &&
      this.userAsiakas.auth.isAsiakasAdmin
    ) {
      response.read = true;
      response.edit = true;
      response.action.delete = true;
    }
    return response;
  };

  init = (asiakas) => {
    // check for errors
    if (!this.user) this.error = { isError: true, message: "User is null" };
    if (asiakas && !asiakas.auth?.isLoaded) {
      console.trace();
      this.error = { isError: true, message: "Auth data is not loaded" };
    }
    if (this.error.isError) {
      console.log("userAuthClass failed", this.error);
      return this;
    }
    const isOwner = asiakas?.ownerAsiakasId === this.userAsiakas?.asiakasId;
    const is = this.is;

    // get user auth
    const isDeveloper = this.user.isDeveloper;
    const isAnyAdmin = asiakas?.auth.isAnyAdmin || (isOwner && this.userAsiakas?.auth?.isAnyAdmin);
    const isAsiakasAdmin =
      asiakas?.auth.isAsiakasAdmin || (isOwner && this.userAsiakas?.auth.isAsiakasAdmin);
    const isLaskuAdmin = isAsiakasAdmin || asiakas?.auth.isLaskuAdmin;
    const isTarjousAdmin = isAsiakasAdmin || asiakas?.auth.isTarjousAdmin;
    const isVehicleHandler = isAsiakasAdmin || asiakas?.auth.isVehicleHandler;
    const isTuoteHandler = isAsiakasAdmin || asiakas?.auth.isTuoteHandler;
    const isSijaintiHandler = isAsiakasAdmin || asiakas?.auth.isSijaintiHandler;
    const isAttachmentHandler = isAsiakasAdmin || asiakas?.auth.isAttachmentHandler;
    const isKeikkaHandler = isAsiakasAdmin || asiakas?.auth.isKeikkaHandler;
    const isPumppari = asiakas?.auth.isPumppari;
    const isAssignee = asiakas?.auth.isAssignee;
    const isAnyWorker = isPumppari || isAnyAdmin || asiakas?.auth.isAnyWorker;
    const isRoleManager = isAsiakasAdmin && this.user.isRoleManager;
    const isAsiakasEditor = isAsiakasAdmin || asiakas?.auth.isAsiakasEditor;

    // is
    is.pumppari = isPumppari;
    is.assignee = isAssignee;
    is.asiakasAdmin = isAsiakasAdmin;
    is.systemAdmin = this.user.isSystemAdmin;

    // modules
    const hasLaskutus = asiakas?.hasLaskutus;
    const hasTyö = asiakas?.hasTyö;
    const hasAjoneuvot = asiakas?.hasAjoneuvot;
    const hasHenkilöt = asiakas?.hasHenkilöt;
    const hasPumifi = asiakas?.hasPumifi;
    const hasTuotteet = asiakas?.hasTuotteet;
    const hasSijainnit = asiakas?.hasSijainnit;
    const hasLiitteet = asiakas?.hasTiedostot;

    // actions
    this.action.keikka.create = isKeikkaHandler || isAsiakasAdmin || isAsiakasEditor;
    this.action.palkki.create = this.action.keikka.create;
    this.action.person.delete = isAsiakasEditor || is.systemAdmin;

    // asiakas
    this.asiakas.read = asiakas?.auth.read || (isOwner && this.userAsiakas?.auth.read);
    this.asiakas.edit =
      asiakas?.auth.originalEdit || (isOwner && this.userAsiakas?.auth.originalEdit);

    // asetukset
    this.asetukset.read = isAsiakasAdmin;
    // asetus - roles
    this.asetukset.roles.read = isAsiakasAdmin;
    if (isAsiakasAdmin && isRoleManager) {
      this.modules.edit = true;
      this.asetukset.roles.edit = true;
      this.asetukset.edit = true;
    }
    // asetus - vakiot
    this.asetukset.vakiot.read = isAsiakasAdmin && isRoleManager;
    this.asetukset.vakiot.edit = is.systemAdmin;

    // modules
    this.modules.read = isAsiakasAdmin;
    // module - sijainnit
    if (hasSijainnit) {
      this.modules.sijainnit.enabled = true;
      this.modules.sijainnit.read =
        isAnyAdmin || isAsiakasAdmin || isSijaintiHandler || asiakas?.auth.originalEdit;
      this.modules.sijainnit.edit = isAsiakasAdmin || isSijaintiHandler;
    }
    // module - tuotteet
    if (hasTuotteet) {
      this.modules.tuotteet.enabled = true;
      this.modules.tuotteet.read =
        isAnyAdmin || isTuoteHandler || isLaskuAdmin || asiakas?.auth.originalEdit;
      this.modules.tuotteet.edit = isAsiakasAdmin || isTuoteHandler || isLaskuAdmin;
    }
    // module - ajoneuvot
    if (hasAjoneuvot) {
      this.modules.ajoneuvot.enabled = true;
      this.modules.ajoneuvot.read = isAnyAdmin || isVehicleHandler || this.asiakas.edit;
      this.modules.ajoneuvot.edit = isAsiakasAdmin || isVehicleHandler;
      this.page.report.daily.vehicle.read = isAnyWorker;
      this.page.report.daily.capacity.read = isAnyAdmin;
      this.page.report.daily.capacity.send = isAsiakasAdmin || isKeikkaHandler;
    }
    // module - henkilöt
    this.modules.henkilöt.enabled = hasHenkilöt;
    this.modules.henkilöt.read = isAnyAdmin;
    this.modules.henkilöt.edit = isAsiakasAdmin;
    this.modules.henkilöt.foreignKeys.read = isAnyAdmin;
    this.modules.henkilöt.foreignKeys.edit = isAsiakasAdmin;

    // module - laskutus
    this.modules.laskutus.enabled = hasLaskutus;
    this.modules.laskutus.read = isLaskuAdmin;
    this.modules.laskutus.edit = isLaskuAdmin;
    this.page.lasku.read = hasLaskutus && (isLaskuAdmin || isAsiakasAdmin);
    this.page.lasku.edit = hasLaskutus && (isLaskuAdmin || isAsiakasAdmin);
    this.page.tarjous.read = isAsiakasAdmin || isTarjousAdmin || isLaskuAdmin;
    this.page.tarjous.edit = isAsiakasAdmin || isTarjousAdmin || isLaskuAdmin;

    // module - pumifi
    if (hasPumifi) {
      this.modules.pumifi.enabled = true;
      this.modules.pumifi.read = isAnyAdmin;
      this.modules.pumifi.edit = isAsiakasAdmin;
    }
    // module - liitteet
    if (hasLiitteet) {
      this.page.liite.read = isAnyAdmin || isAttachmentHandler || isKeikkaHandler;
      this.page.liite.list = isAttachmentHandler || isAsiakasAdmin || isKeikkaHandler;
      this.page.liite.edit = isAttachmentHandler || isAsiakasAdmin;
    }
    // module - työ
    if (hasTyö) {
      this.page.report.daily.driver.read = isAnyWorker;
      this.page.report.stats.pumppari.read = isAnyAdmin;
      this.page.tyot.edit = isAsiakasAdmin;
      this.page.tyot.toimitus.selectPerson = isAsiakasAdmin || isLaskuAdmin;
      this.page.tyot.toimitus.enterData = isAsiakasAdmin || isLaskuAdmin || isPumppari;
      this.page.tyot.hallinta.read = isAsiakasAdmin || isTarjousAdmin || isLaskuAdmin;

      this.page.tyot.read = isAsiakasAdmin || isPumppari;
      this.page.tyot.laskutus.read = this.page.lasku.read;
      this.page.tyot.toimitus.read = this.page.report.daily.driver.read;
      this.page.tyot.liite.read = this.page.liite.read;
    }

    // pages
    this.page.koti.read = true;
    this.page.list.read = true;
    this.page.user.read = true;
    this.page.grid.read = isAnyAdmin || isAsiakasAdmin || isPumppari;
    this.page.grid.edit = isKeikkaHandler || isAsiakasAdmin;
    this.page.grid.drivers.read = isAnyAdmin || isAsiakasAdmin || isPumppari;
    this.page.grid.drivers.edit = isKeikkaHandler || isAsiakasAdmin;
    this.page.grid.reminders.read = isAsiakasAdmin || isKeikkaHandler;
    this.page.grid.reminders.execute = isAsiakasAdmin || isKeikkaHandler;
    this.page.grid.reminders.create = is.systemAdmin;
    this.page.grid.settings.edit = isAsiakasAdmin || isKeikkaHandler;
    this.page.grid.tilaus.tabs.teksti.read = isAnyAdmin || isPumppari;
    this.page.userAsiakas.read = isAnyAdmin;
    this.page.haku.read = isAnyAdmin;
    this.page.report.stats.dash.read = isAsiakasAdmin;
    this.page.loma.read = hasHenkilöt && isAsiakasAdmin;

    this.page.ai.read = isDeveloper || is.systemAdmin;

    // System Admin
    if (is.systemAdmin) {
      this.page.admin.read = true;
      this.asetukset.roles.read = true;
      this.asetukset.roles.edit = true;
      this.asetukset.lisänimet.read = true;
      this.asetukset.lisänimet.edit = true;
      this.modules.read = true;
      this.modules.edit = true;
      this.modules.ajoneuvot.read = hasAjoneuvot;
      this.modules.ajoneuvot.edit = hasAjoneuvot;
      this.modules.henkilöt.read = hasHenkilöt;
      this.modules.henkilöt.edit = hasHenkilöt;
      this.modules.laskutus.read = hasLaskutus;
      this.modules.laskutus.edit = hasLaskutus;
      this.modules.sijainnit.read = hasSijainnit;
      this.modules.sijainnit.edit = hasSijainnit;
      this.modules.tuotteet.read = hasTuotteet;
      this.modules.tuotteet.edit = hasTuotteet;
      this.modules.modules.read = true;
      this.modules.modules.edit = true;
      this.asiakas.action.delete = true;
      this.asiakas.edit = true;
    }

    this.page.report.read = isAnyWorker || this.page.report.stats.dash.read;
    this.page.report.stats.kustannuspaikat.read = this.page.lasku.read;
    this.page.report.stats.stat.read = this.page.report.stats.dash.read;
    this.page.report.stats.stat.main.read = this.page.report.stats.dash.read;
    this.page.report.stats.stat.vehicleDriver.read =
      this.page.report.stats.dash.read && (hasAjoneuvot || hasTyö);

    this.isLoaded = true;

    return this;
  };
}
